import { getCurrentUserId } from "./basicPlanAccess";

export const isAdminSupportContact = (userId) =>
  /^admin/i.test(String(userId || ""));

export const getAdminSupportContactId = () => {
  const userId = getCurrentUserId();
  if (!userId) return null;
  return `admin${userId}`;
};

export const getAdminSupportChatPath = () => {
  const adminId = getAdminSupportContactId();
  return adminId ? `/chat/${adminId}` : "/chat";
};
